module.exports = __webpack_public_path__ + "img/novipos-logo.06147ef4.png";